import { LOGIN, LoginActionType } from "./types";

export const loginReducer = (state: any = {}, action: LoginActionType) => {
    switch (action.type) {
        case LOGIN.REQUEST:
        case LOGIN.SUCCESS:
            return {
                ...state,
                ...action.payload,
                authFailure: null,
            };
        case LOGIN.FAILURE:
            return {
                ...state,
                loading: false,
                query: null,
                error: action.payload.error,
                authFailure: action.payload.data,
                // A bad password must not replace an existing session.
                data: state.data?.cognitoJWT ? state.data : action.payload.data,
            };
        case LOGIN.CLEAN:
            return {
                ...state,
                loading: false,
                query: null,
                error: null,
                authFailure: null,
                data: state.data?.cognitoJWT ? state.data : {},
            };
        default:
            return state;
    }
};
